import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Currency } from '../../../shared/models/currency-list';
import { EventsService, StorageService, VariablesService } from '../../../shared/services';

@Component({
  selector: 'app-other-amount-nudge',
  templateUrl: './other-amount-nudge.component.html',
  styleUrls: ['./other-amount-nudge.component.scss']
})
export class OtherAmountNudgeComponent implements OnInit, OnChanges {

  @Input() currency;
  @Input() selectedCurrency;
  @Input() amount;
  @Input() contribute;
  @Output() amt = new EventEmitter();
  data: any;
  number;
  nudge: any = true;
  limitArray = [0, 1, 2, 3, 4, 5];
  currencies = { 'INR': [200, 300, 500], 'USD': [10, 15, 20], 'GBP': [10, 15, 20], 'EUR': [10, 15, 20], 'SAR': [40, 60, 80], 'AED': [35, 55, 75], 'SGD': [15, 20, 25] };
  nudgeAddAmount;

  constructor(
    public storageService: StorageService,
    public event: EventsService,
    public vars: VariablesService
  ) { }

  ngOnInit(): void {
    this.showData();
  }

  ngOnChanges() {
    if ((this.amount >= this.contribute?.slabs[2])) {
      this.nudge = false;
    } else if ((this.amount < this.contribute?.slabs[2]) && !this.nudge && !this.storageService.getFromSession('nudge')) {
      this.nudge = true;
      this.showData();
    }
  }

  showData() {
    const cur = this.selectedCurrency || this.currency || 'INR';
    const symbol = Currency.find((item) => item.currency === cur.toUpperCase()).symbol;
    this.data = [
      { text: `Donate just ${symbol + this.currencies[cur][1]} more & <strong>save a life quicker</strong>`, amount: `Add ${symbol + this.currencies[cur][1]}` },
      { text: `For as little as <strong>${symbol + this.currencies[cur][1]}</strong> more, you can help get this campaign to its target goal`, amount: `Add ${symbol + this.currencies[cur][1]}` },
      { text: `Just <strong>${symbol + this.currencies[cur][0]}</strong> more will help save this patient’s life quicker`, amount: `Add ${symbol + this.currencies[cur][0]}` },
      { text: `By donating <strong>${symbol + this.currencies[cur][0]}</strong> more, you can help save a life quicker `, amount: `Add ${symbol + this.currencies[cur][0]}` },
      { text: `If you donate <strong>${symbol + this.currencies[cur][2]}</strong> more, you’ll be in the top 20% donors`, amount: `Add ${symbol + this.currencies[cur][2]}` },
      { text: `Make your gift most valuable by giving just <strong>${symbol + this.currencies[cur][1]}</strong> more`, amount: `Add ${symbol + this.currencies[cur][1]}` },
    ];
    if (cur === 'INR') {
      this.data[0].text = `Donate just ${symbol + this.currencies[cur][1]} more & enjoy <strong>higher savings with 80G tax benefits</strong>`;
      this.data[4].text = `If you donate <strong>${symbol + this.currencies[cur][2]}</strong> more, you’ll be in the top 20% of Indian donors`;
    }
    this.number = this.getIndex();
  }

  getIndex() {
    if (!this.storageService.getFromSession('nudge_index')) {
      this.storageService.addSessionData('nudge_index', this.limitArray);
    }
    const temparray = this.storageService.getFromSession('nudge_index');
    this.number = temparray.splice(Math.floor(Math.random() * temparray.length), 1);
    this.storageService.addSessionData('nudge_index', temparray);
    if (this.storageService.getFromSession('nudge_index')?.length === 0) {
      this.storageService.addSessionData('nudge_index', this.limitArray);
    }
    return this.number[0];
  }

  addAmount() {
    this.storageService.addSessionData('nudge', true);
    this.nudge = false;
    const cur = this.selectedCurrency || this.currency || 'INR';
    const i = this.number === 2 || this.number === 3 ? 0 : this.number === 4 ? 2 : 1;
    this.amt.emit({ 'amount': this.amount + this.currencies[cur][i] });
    this.nudgeAddAmount = this.currencies[cur][i];

    const payload = {
      eventName: 'amount_nudge_clicked',
      event_type: 'campaign',
      event_type_id: 635441,
      page_name: this.vars.pageName || '',
      info_1: this.nudgeAddAmount
    };
    this.event.sendSystemEvent(payload).subscribe(_ => _);
  }

}
